const defaults = {
    relaySort: 'default', // or 'popular'

    lectureKeyword: '',
    lectureCheck: false,
    currentLecture: {},
    lectureCheckRes: {},
    lectureList: null,
    lectureOffset: 0,
    lectureHasMore: true,
    lectureIsAsking: false,

    channelKeyword: '',
    channelList: null,
    currentChannel: {},
    channelCheck: false,
    channelCheckRes: {},
    channelOffset: 0,
    channelHasMore: true,
    channelIsAsking: false,
}

export default (state = defaults, action) => {
    switch (action.type) {
        case 'RELAY_INIT':
            return defaults
        case 'RELAY_SET_SORT':
            return { ...state, relaySort: action.payload }
            
        case 'RELAY_SET_LECTURE_CHECK':
            return { ...state, lectureCheck: action.payload }
        case 'RELAY_SET_CURRENT_LECTURE':
            return { ...state, currentLecture: action.payload }
        case 'RELAY_SET_LECTURE_CHECK_RES':
            return { ...state, lectureCheckRes: action.payload }
        case 'RELAY_SET_LECTURE_OFFSET':
            return { ...state, lectureOffset: action.payload }
        case 'RELAY_SET_LECTURE_LIST':
            return { ...state, lectureList: action.payload }
        case 'RELAY_SET_LECTURE_LIST_INIT':
            return { ...state, lectureList: defaults.lectureList }
        case 'RELAY_SET_LECTURE_HAS_MORE':
            return { ...state, lectureHasMore: action.payload }
        case 'RELAY_SET_LECTURE_IS_ASKING':
            return { ...state, lectureIsAsking: action.payload }
        case 'RELAY_SET_LECTURE_KEYWORD':
            return { ...state, lectureKeyword: action.payload }

        case 'RELAY_SET_CHANNEL_LIST':
            return { ...state, channelList: action.payload }
        case 'RELAY_SET_CURRENT_CHANNEL':
            return { ...state, currentChannel: action.payload }
        case 'RELAY_SET_CHANNEL_CHECK':
            return { ...state, channelCheck: action.payload }
        case 'RELAY_SET_CHANNEL_CHECK_RES':
            return { ...state, channelCheckRes: action.payload }
        case 'RELAY_SET_CHANNEL_OFFSET':
            return { ...state, channelOffset: action.payload }
        case 'RELAY_SET_CHANNEL_HAS_MORE':
            return { ...state, channelHasMore: action.payload }
        case 'RELAY_SET_CHANNEL_IS_ASKING':
            return { ...state, channelIsAsking: action.payload }
        case 'RELAY_SET_CHANNEL_KEYWORD':
            return { ...state, channelKeyword: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/relays.js